import { render, staticRenderFns } from "./Course_wrap.vue?vue&type=template&id=39756f4e"
import script from "./Course_wrap.vue?vue&type=script&lang=js"
export * from "./Course_wrap.vue?vue&type=script&lang=js"
import style0 from "./Course_wrap.vue?vue&type=style&index=0&id=39756f4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports